"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  qualityFile: {
    home: {
      enterFileNo: 'Please enter the No. Or Keyword'
    },
    index: {
      title: 'HSQE Manual Maintenance',
      item: 'Manual Maintenance',
      pleaseEnter: 'Please enter the required content',
      moduleCodingDuplication: 'Code duplicate ',
      fileNo: 'DOC. No.',
      fileName: 'DOC. Name',
      enterFileNo: 'Please enter the DOC. No.',
      enterFileName: 'Please enter the DOC. Name',
      button: {
        editCatalog: 'Catalog Management',
        editVersion: 'Version Management',
        addQualityFile: 'Add DOC.',
        editQualityFile: 'Revise DOC.',
        editCatalogHistory: 'Revised DOC. History',
        btnPublish: 'Release',
        fileSearch: 'Search'
      },
      query: {
        itemName: 'Item Name',
        vesselControlledFile: 'Vessel Supportive File',
        controlledFile: 'Manual Manage',
        controlledRecord: 'Form Manage',
        otherControledFile: 'File Manage ',
        otherControlledDocuments: 'Catalog for Other Controlled DOC.'
      },
      table: {
        qualityFileNo: ' DOC. No.',
        qualityFileName: 'DOC. Name',
        qualityVersion: 'Major Version',
        source: 'Origin',
        qualityType: 'Type',
        qualityStatus: 'Status',
        publishDate: 'Released Date',
        relatedAttach: 'Attachment',
        qualityReviseVersion: 'Edition Version',
        qualityFileDate: 'Effective Date',
        qualityDueDate: 'Expired Date',
        sysPostId: 'Position/Rank',
        qualityFileStatus: 'Status',
        qualityFileInfoId: 'Related Documents',
        qualityRecordInfoId: 'Related Forms',
        name: 'DOC. Name',
        initiateSystemImprovement: 'Start Improvement'
      }
    },
    editQualityFile: {
      tab: {
        fileInformation: 'DOC. Info.',
        recordInformation: 'Form Info.',
        historicalVersion: 'Revised History'
      },
      form: {
        taskAssign: 'Learning Task Assignment',
        yes: 'Y',
        no: 'N',
        examFlag: 'Need Exam',
        fileRootId: 'ID',
        qualityCatalog: 'Catalog',
        qualityRecordVersion: ' Major Version',
        qualityReviseVersion: 'Edition Version',
        qualityReviseEditVersion: 'Edition Version',
        attachInfo: 'Attachment(Including Cn and En)',
        operateType: 'Operate Type',
        qualityFileNo: 'DOC. No.',
        qualityFileDate: 'Effective Date',
        qualityFileNameCn: 'DOC. Name(Cn)',
        qualityFileNameEn: 'DOC. Name(En)',
        createOffice: 'Created by',
        syncFlag: 'Sync(Ship & Shore)',
        sysOrgId: 'Related Dept.',
        sysPostId: 'Related Position',
        shipPostId: 'Related Ship Rank',
        sysVesselType: 'Ship Type',
        relaxQualityFile: 'Related DOC.',
        relaxRecord: 'Related Forms',
        standardInfoId: 'Related Standards',
        mainBody: 'DOC. Body',
        upMainBody: 'Upload Body',
        attachmentsInfoId: 'Attachment',
        uploadAttachment: 'Upload Attachment',
        updateContext: 'Updated Details',
        taskName: 'Task Name',
        learnFlag: 'If Learning',
        learnDeadline: 'Expected Completion Date',
        learnDept: 'Department',
        learnShip: 'Ship',
        ship: 'Ship',
        learnRemark: 'Requirement',
        feedBack: 'Feedback',
        shoreLearnPost: 'Position of Shore Based',
        shipLearnPost: 'Rank of Ship',
        qualityFileName: 'DOC. Name',
        qualityDueDate: 'Expired Date',
        monitorPost: 'Monitor Post',
        monitorDept: 'Monitor Dept.',
        remindDate: 'Remind Date',
        inputCircle: 'Fill In Circle',
        circleFlag: 'Circle Remind',
        monitorRemind: 'Monitor Remind',
        tableTemplate: 'Template'
      }
    },
    editCatalog: {
      item: 'Catalog',
      table: {
        catalogNameCn: 'Catalog Name',
        lastModifyTime: 'Modify Date',
        catalogRemark: 'Remark'
      },
      form: {
        parentName: 'Parent Catalog',
        catalogName: 'Catalog Name',
        catalogNameCn: 'Catalog Name(Cn)',
        catalogNameEn: 'Catalog Name(En)',
        dispOrder: 'Display Order',
        catalogRemark: 'Remark',
        catalogType: 'Type'
      }
    },
    editVersion: {
      item: 'Major Version',
      table: {
        sysOrgId: 'Company Name ',
        qualityRecordVersion: 'Version',
        relaxRecord: 'Related Forms',
        qualityFileDate: 'Effective Date',
        remarks: 'Remark'
      },
      form: {
        sysOrgId: 'Company',
        qualityRecordVersion: 'Version',
        qualityFileDate: 'Effective Date',
        remarks: 'Remark'
      }
    },
    catalogHistory: {
      item: 'HSQEMS Revise History',
      table: {
        qualityFileNo: 'DOC. No.',
        qualityFileName: 'DOC. Name',
        qualityVersion: 'Major Version',
        qualityReviseVersion: 'Edition Version',
        qualityFileDate: 'Effective Date',
        sysOrgId: 'Modified by Dept.',
        updateContext: 'Updated Details',
        approve: 'Approved by',
        reviser: 'Modified by'
      }
    },
    updateContext: {
      item: 'Replace Body',
      optionDoc: 'Select Files',
      table: {
        context: 'DOC. Text(Clear PDF in Chinese)',
        reviseContext: 'DOC. Text(Revised Edition PDF in Chinese )',
        contextEn: 'DOC. Text(Clear PDF in English)',
        reviseContextEn: 'DOC. Text(Revised Edition PDF in English )',
        associatedFile: 'Related DOC.',
        associatedTable: 'Form(s)'
      }
    },
    title: {
      replaceFile: 'Replace File',
      modifyTestQuestions: 'Modify Test Questions'
    },
    msg: {
      saveSuccess: 'Saved successfully'
    }
  },
  qualityRecord: {
    index: {
      title: 'HSQE Manual Maintenance',
      item: 'Form Maintenance',
      learningRecordQuery: 'Study History',
      requiredCompletionDate: 'Expected Completion Date',
      query: {
        itemName: 'Item Name'
      },
      table: {
        taskType: 'Task Type',
        filePath: 'File Path',
        feedbackContent: 'Feedback Content',
        attachment: 'Attachment',
        qualityRecordNo: 'Form No.',
        qualityRecordName: 'Form Name',
        qualityRecordNameCn: 'Form Name(Cn)',
        qualityRecordNameEn: 'Form Name(En)',
        qualityRecordVersion: 'Major Version',
        qualityReviseVersion: 'Edition Version',
        qualityRecordDate: 'Effective Date',
        qualityDueDate: 'Expired Date',
        sysPostId: 'Related Position/Rank',
        validFlag: 'Status',
        recordLocation: 'Storage Location',
        recordSaveTime: 'Storage Term',
        attachmentsName: 'Related DOC. ',
        eventInfoId: 'Related Activity',
        relatedBusiness: 'Related Business',
        fileName: 'Form Name',
        enterFileName: 'Please enter the form name',
        fileNo: 'Form No.',
        fileNoName: 'DOC. No./Name',
        taskName: 'Task Name',
        enterFileNo: 'Please enter the No.',
        companyName: 'Company',
        enterCompany: 'Please select one company'
      }
    },
    editQualityRecord: {
      form: {
        yes: 'Y',
        no: 'N',
        recordRootId: 'ID',
        qualityRecordNo: 'Form No.',
        qualityRecordVersion: 'Major Version',
        qualityReviseVersion: 'Edition Version',
        editType: 'Type',
        qualityRecordNameCn: 'Form Name(Cn)',
        qualityRecordNameEn: 'Form Name(En)',
        qualityRecordDate: 'Effective Date',
        recordSaveTime: 'Storage Term',
        syncFLag: 'Sync(Ship & Shore)',
        qualityRecordDept: 'Created By',
        sysOrgId: 'Related Dept.',
        sysPostId: 'Related Position/Rank',
        qualityFileId: 'Related DOC.',
        standardInfoId: 'Related Standards',
        eventInfoId: 'Related Activity',
        recordLocation: 'Storage Location',
        relatedBusiness: 'Related Business',
        mainBodyCn: 'Form Text(Cn)',
        mainBodyEn: 'Form Text(En)',
        uploadAttachment: 'Upload File',
        tableTemplate: 'Template',
        addTitle: 'Add Form',
        editTItle: 'Edit Form',
        queryTitle: 'View',
        circleFlag: 'Circle Remind'
      }
    }
  },
  benchmark: {
    index: {
      title: 'HSQE Manual Maintenance',
      item: 'Benchmarking',
      query: {
        itemName: 'Item Name'
      },
      table: {
        qualityFileName: 'DOC. Name',
        qualityFileNo: 'DOC. No.',
        qualityFileDate: 'Effective Date',
        qualityDueDate: 'Expired Date'
      }
    }
  },
  standard: {
    index: {
      title: 'HSQE Manual Maintenance',
      item: 'Standard',
      query: {
        itemName: 'Item Name',
        keyContent: 'Standard/Content'
      },
      table: {
        index: 'No.',
        standardCode: 'Code',
        standardContent: 'Content',
        relationFileChapter: 'Statistical Type'
      }
    },
    standardDialog: {
      form: {
        maxLength: 'Must be more than 10 characters',
        standardStatus: 'Status',
        effective: 'Valid',
        loseEfficacy: 'Invalid',
        parentName: 'Parent Name',
        standardType: 'Type',
        standard: 'Standard',
        node: 'Node',
        standardCode: 'Standard Code.',
        dispOrder: 'Display Order',
        standardNameCn: 'Standard Name(Cn)',
        standardNameEn: 'Standard Name(En)',
        standardContent: 'Content',
        qualityFileChapter: 'Chapter',
        rootId: 'Parent Node',
        statisticId: 'Statistical Type'
      }
    }
  },
  qualityFileBusiness: {
    index: {
      title: 'HSQE Manual Maintenance',
      item: 'DOC. & Business Config',
      belongOrgName: 'Company',
      fileAll: 'DOC. Name',
      addFileModuleBtn: 'Add Business Module',
      addFielBusinessBtn: 'Add DOC.',
      query: {
        fileAll: 'Please enter the content'
      },
      businessTable: {
        index: 'No.',
        moduleName: 'Business Module'
      },
      businessRelateTable: {
        index: 'Code',
        fileNo: 'DOC. No.',
        fileName: 'DOC. Name',
        fileOtherName: 'DOC. Alias',
        fileType: 'DOC. Type',
        sortNo: 'Display Order',
        belongOrgName: 'Company'
      }
    },
    editBusinessModuleDialog: {
      module: 'Module',
      task: 'Task',
      activity: 'Activity',
      item: 'Business Module Management',
      form: {
        moduleParentName: 'Parent Module',
        moduleCode: 'Module Code',
        moduleName: 'Module Name',
        moduleNameCn: 'Module Name(Cn)',
        moduleNameEn: 'Module Name(En)',
        dispOrder: 'Display Order',
        moduleRemark: 'Remark'
      },
      formRules: {
        moduleName: 'Module\'s name can not be empty',
        moduleNameCn: 'Module\'s name (Cn) can not be empty',
        moduleNameEn: 'Module\'s name (En) can not be empty',
        moduleCode: 'Module\'s code can not duplicate'
      }
    },
    editBusinessFileDialog: {
      item: 'DOC. & Business Config',
      form: {
        companyId: 'Company',
        moduleId: 'Business Module',
        qualityFileType: 'DOC. Type',
        dispOrder: 'Display order',
        qualityFileId: 'Related DOC.',
        qualityFileNameCn: 'DOC. Name(Cn)',
        qualityFileNameEn: 'DOC. Name(En)'
      }
    }
  },
  qualityFileHome: {
    index: {
      item: 'HSQE Manual Maintenance',
      Document: 'Manual',
      CircularFile: 'Circular',
      ExternalFile: 'External DOC.',
      BestPractices: 'Best Practice',
      ControlledDocument: 'Other controlled DOC.'
    }
  },
  otherFileHome: {
    index: {
      title: 'HSQE Manual Maintenance',
      item: 'File ',
      noesRegulations: 'Circular & Regulation',
      fileCode: 'File No.',
      fileName: 'File Name',
      fileStatus: 'Status',
      fileValidDate: 'Effective',
      table: {
        fileCode: 'File No.',
        fileName: 'File Name',
        fileStatus: 'Status',
        fileValidDate: 'Effective Date',
        fileAttach: 'Attachment',
        uploader: 'Uploaded by',
        uploadDate: 'Uploaded Date'
      }
    }
  },
  integratedQuery: {
    index: {
      filter: {
        pleaseSelect: 'Please Select',
        company: 'Company',
        activityType: 'ACT. Type',
        recordName: 'Form Name',
        vessel: 'Related Ship',
        scope: 'Period',
        deptOrVessel: 'Start by ship/dept.',
        activityStatus: 'Status',
        activityDate: 'Date',
        voyageNo: 'Voyage No.'
      }
    }
  },
  qualityActivity: {
    index: {
      title: 'Implementation',
      item: 'ACT. & Business Config',
      belongOrgName: 'Company',
      activityAll: 'Record Number/Name',
      addFileModuleBtn: 'Add Business Module',
      addActivityBusinessBtn: 'Add',
      query: {
        activityAll: 'Please enter the content'
      },
      businessTable: {
        index: 'No.',
        moduleName: 'Business Module'
      },
      businessRelateTable: {
        index: 'Code',
        activityNo: 'Record Number',
        activityName: 'Record Name',
        activityType: 'Activity Type',
        businessRouterUrl: 'Work Report Routing Address',
        searchRouterUrl: 'Comprehensive Query Routing Address',
        wfCode: 'Workflow Code',
        syncFlag: 'Synchronized',
        sortNo: 'Display Order',
        companyName: 'Company Name'
      }
    },
    editBusinessModuleDialog: {
      module: 'Module',
      task: 'Task',
      activity: 'Activity',
      item: 'Business Module Management',
      form: {
        company: 'Owned Company',
        moduleType: 'Type',
        parentId: 'Parent Node',
        activityName: 'Activity Name',
        activityNameEn: 'Activity English Name',
        dispOrder: 'Display Order',
        moduleRemark: 'Remark'
      },
      formRules: {
        parentId: 'Please select the parent node',
        activityName: 'Please fill in the name of the activity',
        activityNameEn: 'Please fill in the English name of the activity',
        moduleType: 'Please choose the type'
      }
    },
    editBusinessFileDialog: {
      item: 'Activity Association Record Table',
      attchForm: 'Attachment Form',
      textForm: 'Text Form',
      moduleForm: 'Template Form',
      form: {
        businessRouterUrl: 'Work Report Routing Address',
        searchRouterUrl: 'Comprehensive Query Routing Address',
        companyId: 'Owned Company',
        moduleId: 'Business Activity',
        qualityFileType: 'Records',
        inputTemplateUrl: 'Page Load Address',
        mobile: 'Support Mobile Terminal',
        inputType: 'Interface Loading Method',
        dispOrder: 'Display Order',
        wfFlag: 'Whether The Process',
        wfCode: 'Workflow Code',
        syncFlag: 'Data Syn',
        qualityEvent: 'Associated Activities',
        qualityFileNameCn: 'File alias (CN)',
        qualityFileNameEn: 'File alias (EN)'
      },
      rules: {
        wfFlag: 'Please choose whether to go through the process',
        businessRouterUrl: 'Please fill in the job and fill in the routing address',
        searchRouterUrl: 'Please select the integrated query routing address',
        syncFlag: 'Please choose whether to synchronize between ship and shore',
        inputType: 'Please select the interface loading form',
        wfCode: 'Please fill in the workflow code',
        inputTemplateUrl: 'Please fill in the page loading address'
      }
    }
  }
};